import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['index', 'isPricingValueStatic']);
  const createProvisioningAttributesConfig = `createProvisioningAttributesConfig(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createProvisioningAttributesConfig} {
      id
    }
  }
`;
};
